import { Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

type FooterMarginTop = 'sm' | 'lg'

export const FooterContainer = styled.div<{ footerMarginTop: FooterMarginTop }>`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${Spacing.S16} 0;
  border-radius: 12px;
  background-color: ${Color.Purple100};
  // NOTE: Due to the constraints from the parent component,
  // a margin is used here to push the footer to the bottom of the screen
  margin-top: calc(100vh - ${({ footerMarginTop }) => (footerMarginTop === 'lg' ? '685px' : '730px')});
`
